export default function Hero() {
  const handleNavClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen pt-[72px] flex items-center bg-background-50 overflow-hidden">
      <div className="w-full px-4 md:px-6 py-10 md:py-14 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>下拉式漫画 · 流畅阅读新体验</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              43423漫画网 · 下拉式漫画免费在线阅读平台
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-medium mt-3 mb-6">
              一滑到底，畅读无限 —— 你的专属下拉式漫画世界
            </p>

            <div className="space-y-3 text-foreground-700 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              <p>
                43423漫画网专注于下拉式漫画阅读体验，汇集海量韩漫下拉式、日漫下拉式及国产漫画资源。
                采用独特的上下滑动浏览模式，告别传统翻页，让阅读更加自然流畅，沉浸感十足。
              </p>
              <p>
                平台每日更新热门连载，涵盖恋爱、奇幻、动作、悬疑等多元题材。无论你是追更党还是补番控，
                这里都有最适合你的下拉式漫画。无需下载，打开即看，随时随地享受下拉式阅读的乐趣。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-lg text-secondary-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-950">20000+</div>
                  <div className="text-xs text-foreground-600">部漫画资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-timer-flash-line text-lg text-accent-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-950">每日更新</div>
                  <div className="text-xs text-foreground-600">追更不等待</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-lg text-primary-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-950">绿色安全</div>
                  <div className="text-xs text-foreground-600">无广告干扰</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); handleNavClick('carousel'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line"></i>
                开始探索
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); handleNavClick('features'); }}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-background-300 text-foreground-700 font-semibold rounded-full hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20illustration%20of%20a%20smartphone%20displaying%20vertical%20scroll%20comic%20panels%20with%20manga%20style%20characters%2C%20warm%20orange%20and%20coral%20accents%2C%20surrounded%20by%20floating%20comic%20speech%20bubbles%20and%20star%20effects%2C%20modern%20flat%20design%20with%20soft%20gradients%2C%20clean%20cream%20background%2C%20playful%20mood%2C%20digital%20art%20style%2C%20high%20detail%2C%20professional%20illustration&width=960&height=1200&seq=hero-comic-01&orientation=portrait"
                alt="43423漫画网 - 下拉式漫画手机阅读界面展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <a
          href="#carousel"
          onClick={(e) => {
            e.preventDefault();
            handleNavClick('carousel');
          }}
          className="flex flex-col items-center gap-1 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
        >
          <span className="text-xs">向下浏览</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}